import { startOfISOWeek, addWeeks } from 'date-fns';
import { contractDate } from './planningDates';

function date(value) {
  const french = String(value ?? '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return contractDate(french ? `${french[3]}-${french[2]}-${french[1]}` : value);
}
export function inTimesheetWeek(row, week, year) {
  if (row.weekNumber && row.year) return Number(row.weekNumber) === week && Number(row.year) === year;
  const start = date(row.startDate);
  const end = date(row.endDate) || start;
  const weekStart = addWeeks(startOfISOWeek(new Date(year, 0, 4)), week - 1);
  const nextWeek = addWeeks(weekStart, 1);
  return Boolean(start && end && start < nextWeek && end >= weekStart);
}
